<quill-editor [(ngModel)]="content" trackChanges="all" name="TemplateContent" [styles]="styles" placeholder=""
  (onContentChanged)="onChanged($event)">
</quill-editor>